import { useState, useEffect } from 'react';
import { Outlet, useLocation} from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// components
import { useAuthContext } from '../../auth/useAuthContext';
import Notification from '../../components/Notification/Notification';
// sections
import Main from './Main';
import Header from './header';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { user } = useAuthContext();

  const location = useLocation();

  const isUserListPage = location.pathname === '/userListPage';

  const [open, setOpen] = useState(false);

  const [notification, setNotification] = useState(location.state || { open: false, msg: '', type: '' });

  useEffect(() => {
    if (location.state) {
      setNotification(location.state);
    }
  }, [location.state]);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Header onOpenNav={handleOpen} />

      {user && user?.UserTypeID === 1 && isUserListPage ? (
        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
            backgroundColor: 'rgb(0, 0, 0, 0.05)',
            width: '100%',
            mt: 3,
          }}
        >
          <Main>
            <Outlet />
          </Main>
        </Box>
      ) : (
        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          <Main>
            <Outlet />
          </Main>
        </Box>
      )}

      <Notification notification={notification} setNotification={setNotification} />
    </>
  );
}
